// Logging utility no longer relies on Sentry

enum EFeature1Context {
    visitor = 'visitor'
}


export const contextNames = {
    ...EFeature1Context
}

export type TContextName = keyof typeof contextNames
export type TFeatureName = 'edulla-chat' | 'edulla-chat-start'

export const logLevel = 'error'

export function log(
    featureName: TFeatureName,
    errorMessage: string,
    contextName: TContextName,
    properties: object,
    level: string = logLevel,
) {
    console.error(`[${featureName}] ${errorMessage}`, {
        context: contextName,
        level,
        ...properties,
    })
}
